import React from 'react';
import { BoundSelect } from "../BoundSelect";
import { SubscriptionType } from "../../../../constants/securspace-constants";

type BoundSubscriptionTypeSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundSubscriptionTypeSelect = <T,>({
  label = "Subscription Type",
  name,
  value = '',
  onChange
}: BoundSubscriptionTypeSelectProps<T>) => {

  return <BoundSelect<T>
    options={SubscriptionType}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundSubscriptionTypeSelect };